export default class Constants {
  public static ComposantsName = class {
    static ClientSpaceSnackBar = 'ClientSpaceSnackBar';
  };

  public static DefaultPaths = class {
    static Unauthorized = '/unauthorized';
  };
}
